<template>
  <div>
    <b-form @submit.prevent="onSubmit">
      <div v-if="error" class="alert alert-danger">
        {{error}}
      </div>
      <b-overlay spinner-variant="info" :opacity="0.5" :show="loading">
      <b-container>
        <b-row class="newAttr">
          <b-col><label for="sexId">Пол</label></b-col>
          <b-col><b-form-select id="sexId" v-model="localParamFactorBand.sexId" :options="genderOptions" required :select-size="1"></b-form-select></b-col>
        </b-row>
        <b-row v-if="paramType !== 2 && paramType !== 7" class="newAttr">
          <b-col><label for="zoneId">Интервал</label></b-col>
          <b-col>
            <b-form-select v-if="factorBand" id="zoneId" v-model="localParamFactorBand.zoneId" :options="zoneOptions" required :select-size="1"></b-form-select>
            <b-form-checkbox-group v-else
              v-model="localParamFactorBand.zones"
              :options="zoneOptions"
              id="zoneId"
              stacked></b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row v-if="paramType === 2 || paramType === 7" class="newAttr">
          <b-col><label for="zoneId">Варианты ответа</label></b-col>
          <b-col>
            <b-form-select v-if="factorBand" id="zoneId" v-model="complexPropValue" :options="propertyValueOptions" required :select-size="1"></b-form-select>
            <b-form-checkbox-group v-else
                                   v-model="complexPropValues"
                                   :options="propertyValueOptions"
                                   text-field="text"
                                   value-field="value"
                                   id="zoneId"
                                   stacked>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row v-if="factorValue === 'ParamRecommended'" class="newAttr">
          <b-col><label for="recommendationTypeId">Критичность рекомендации</label></b-col>
          <b-col>
            <b-form-select id="recommendationTypeId" v-model="localParamFactorBand.recommendationTypeId" :options="recommendationOptions" required :select-size="1"></b-form-select>
          </b-col>
        </b-row>
<!--        <b-row class="newAttr">-->
<!--          <b-col><label for="priorityReport">Приоритет</label></b-col>-->
<!--          <b-col><b-form-input id="priorityReport" type="number" required  v-model="localParamFactorBand.priorityReport"></b-form-input></b-col>-->
<!--        </b-row>-->
        <b-row class="newAttr">
          <b-col>
            <label v-if="factorValue === 'RecommendExamination'" for="factorId">Рекомендуемые исследования</label>
            <label v-else for="factorId">Рекомендуемые аналиты</label>
          </b-col>
          <b-col>
            <b-form-select v-if="factorBand" id="factorId" v-model="localParamFactorBand.factorId" :options="factorOptions" required :select-size="1"></b-form-select>
            <treeselect v-else name="factorId" id="factorId" placeholder=""
                        multiple clearable searchable
                        open-on-click close-on-select :flat="true"
                        :noResultsText="'Не найдено...'"
                        :options="factorOptions"
                        :max-height="200"
                        :normalizer="normalizeTreeselect"
                        v-model="localParamFactorBand.factors" />
          </b-col>
        </b-row>
        <b-row class="newAttr">
          <b-col>
            <b-button variant="info" type="submit" >Сохранить</b-button>
          </b-col>
        </b-row>
      </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import {host} from "@/constants";
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


export default {
  props: {
    analitId: String,
    factorValue: String,
    factorBand: Object,
    paramType: String
  },
  name: "RecommendationEdit",
  data () {
    return {
      loading: false,
      factorOptions: [],
      genderOptions: [{value:0,text:'мужской и женский'},{value:1,text:'мужской'},{value:2,text:'женский'}],
      zoneOptions: [],
      recommendationOptions: [],
      complexPropValue: this.factorBand ? this.factorBand.propertyId + ',' + this.factorBand.propertyValueId : null,
      complexPropValues: [],
      error: null,
      localParamFactorBand: this.factorBand ? this.factorBand : {
        paramFactorBandId: 1,
        sexId: 0,
        factorId: null,
        factors: null,
        priorityReport: 0,
        zoneId: null,
        zones: [],
        recommendationTypeId: null,
        propertyValueId: null,
        propertyId: null,
        propertyValues: []
      },
      normalizeTreeselect(node) {
        return {
          id: node.value,
          label: node.text
        }
      }
    }
  },
  components: {Treeselect},
  methods: {
    fetchDictsData() {
      fetch(host + '/rest/dicts/zone/' + this.paramType)
          .then(response => response.json())
          .then(json => {
            this.zoneOptions = json.options
            console.log(json)
          })
      fetch(host + '/rest/dicts/recommendationtype')
          .then(response => response.json())
          .then(json => {
            this.recommendationOptions = json.options
            console.log(json)
          })
      fetch(host + '/rest/factors/' + this.factorValue, {
        credentials: 'include'
      })
          .then(response => response.json())
          .then(json => {
            this.factorOptions = json.options
            console.log(json)
          })
      fetch(host + '/rest/params/' + this.analitId + '/properties/values/dict', {
        credentials: 'include'
      })
          .then(response => response.json())
          .then(json => {
            this.propertyValueOptions = []
            for (let opt of json.options) {
              if (opt.value && opt.propertyId && opt.propertyId > 0) {
                this.propertyValueOptions.push( {
                  value: opt.propertyId + ',' + opt.value,
                  text: opt.propertyName + ', ' + opt.text
                })
              }
            }
          })
    },
    onSubmit() {
      this.loading = true
      let method = 'POST'
      if (this.factorBand) {
        method = 'PUT'
        this.localParamFactorBand.zones = null
        this.localParamFactorBand.factors = null
        this.localParamFactorBand.propertyValues = null
        if (this.paramType === 2 || this.paramType === 7) {
          const propIds = this.complexPropValue.split(',')
          this.localParamFactorBand.propertyId = propIds[0]
          this.localParamFactorBand.propertyValueId = propIds[1]
          this.localParamFactorBand.zoneId = null
        } else {
          this.localParamFactorBand.propertyId = null
          this.localParamFactorBand.propertyValueId = null
        }

      } else {
        if (this.paramType === 2 || this.paramType === 7) {
          this.localParamFactorBand.propertyValues = []
          for (let a of this.complexPropValues) {
            const propIds = a.split(',')
            this.localParamFactorBand.propertyValues.push({value: propIds[1], propertyId: propIds[0]})
          }
        }
      }

      console.log(JSON.stringify(this.mu))
      fetch(host + '/rest/params/' + this.analitId + '/factors/' + this.factorValue, {
        method: method,
        credentials: 'include',
        body: JSON.stringify(this.localParamFactorBand),
        headers: {'Content-Type': 'application/json; charset=utf-8'}
      }).then(response => response.json())
          .then(json => {
            this.loading = false
            if (json.resultCode == 0) {
              console.log('Save Success ' + JSON.stringify(json))
              this.$emit('save-success')
            } else {
              console.log('Save Failed ' + json)
              this.error = json.resultCode + ' ' + json.message;
            }
          })
          .catch(error => {
            this.error = error
            this.loading = false
            console.log(JSON.stringify(error))
          })

    }
  },
  mounted() {
    this.fetchDictsData()
  }
}
</script>

<style scoped>

.newAttr {
  padding-top: 1rem;
}

</style>